import { Component, Input } from '@angular/core';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';

@Component({
    selector: 'app-help-button',
    template: `
    <button
      tabindex="0"
      role="button"
      [attr.aria-label]="'Open Help Information' | translation: translationRequest"
      [attr.aria-describedby]="id"
      (click)="detailOverlay.open()"
      (keyup.enter)="detailOverlay.open()"
      [attr.aria-expanded]="detailOverlay.opened ? 'true' : 'false'"
      >
      <mat-icon
        class="help-icon"
        cdkOverlayOrigin
        [style.width]="size + 'px'"
        [style.height]="size + 'px'"
        [style.font-size]="size + 'px'"
        #detailOrigin="cdkOverlayOrigin"
        >help_outline</mat-icon
        >
      </button>
    
      <app-overlay [origin]="detailOrigin" #detailOverlay>
        @if (detailOverlay.opened) {
          <app-panel
            [showTitle]="false"
            [canExpand]="false"
            >
            <div
              role="tooltip"
              [id]="id"
              class="app-pt1 tw-pb-2 message-container"
              [innerHTML]="message | translation: translationRequest"
            ></div>
          </app-panel>
        }
      </app-overlay>
    `,
    styles: [
        `
      .message-container {
        max-width: 300px;
        font-size: 13px;
      }
      .help-icon {
        margin-left: 4px;
        color: var(--color-input-grey);
        cursor: pointer;
        vertical-align: middle;
      }
    `,
    ],
    standalone: false
})
export class HelpButtonComponent {
  @Input()
  size: number = 18;

  translationRequest: TranslationRequest = new TranslationRequest({
    language: sessionStorage.getItem('languagepreference'),
    key: null,
    contNum: 0,
    tableName: null,
    primaryKey: null,
    primaryValue: null,
    lob: null,
    group: 'Shared',
    subGroup: 'Shared',
  });

  @Input()
  message: string = 'TODO: provide message';

  @Input()
  id: string = 'tooltipId';
}
